export const COMPANY = {
  name: "1st Home Care Services, LLC",
  dba: "1st Home Care",
  phone: "703-981-8201",
  phoneTel: "+17039818201",
  emails: ["1sthomecarenova@gmail.com"],
  primaryEmail: "1sthomecarenova@gmail.com",
  address: {
    street: "6315 Backlick Road Suite 101",
    city: "Springfield",
    state: "VA",
    zip: "22150",
  },
  fullAddress: "6315 Backlick Road Suite 101, Springfield, VA 22150",
  serviceArea: [
    "Fairfax County",
    "Prince William County",
    "Loudoun County",
    "Arlington County",
    "City of Alexandria",
    "City of Fairfax",
    "City of Manassas",
    "City of Manassas Park",
    "City of Falls Church",
  ],
  logo: "https://customer-assets.emergentagent.com/job_25fc6c60-656e-413f-9f48-2489a34dc777/artifacts/hift4tj9_Screenshot%202026-05-04%20at%2011.13.48%E2%80%AFAM.png",
};

export const CARE_TYPES = [
  "Skilled Nursing",
  "Private Duty Nursing",
  "Personal Care",
  "Respite Care",
  "Not Sure — Need Guidance",
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/service-area", label: "Service Area" },
  { to: "/about", label: "About" },
  { to: "/resources", label: "Resources" },
  { to: "/faq", label: "FAQ" },
  {
    to: "/contact",
    label: "Contact",
    submenu: [
      { to: "/contact", label: "Contact Us" },
      { to: "/contact/payment", label: "Payment" },
    ],
  },
];

export const HOME_SUB_LINKS = [
  { to: "/referral", label: "Referral Form" },
  { to: "/contact", label: "Set an Appointment" },
  { to: "/survey", label: "Client Satisfaction Survey" },
];

export const OFFICE_HOURS = [
  { day: "Mon", time: "9:00 AM – 5:00 PM" },
  { day: "Tue", time: "9:00 AM – 5:00 PM" },
  { day: "Wed", time: "9:00 AM – 5:00 PM" },
  { day: "Thu", time: "9:00 AM – 5:00 PM" },
  { day: "Fri", time: "9:00 AM – 5:00 PM" },
  { day: "Sat", time: "Closed (On Call)" },
  { day: "Sun", time: "Closed (On Call)" },
];

export const IMAGES = {
  heroNurse: "https://customer-assets.emergentagent.com/job_homecare-nova-1/artifacts/lxo3wioc_Screenshot%202026-06-04%20at%201.43.17%E2%80%AFPM.png",
  elderlyCouple: "https://images.pexels.com/photos/7551672/pexels-photo-7551672.jpeg?auto=compress&cs=tinysrgb&w=1600",
  leadership: "https://images.pexels.com/photos/5215024/pexels-photo-5215024.jpeg?auto=compress&cs=tinysrgb&w=1600",
  personalCare: "https://images.unsplash.com/photo-1765896387398-1e1ae8d2eb85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxudXJzZSUyMGhlbHBpbmclMjBzZW5pb3IlMjBjaXRpemVufGVufDB8fHx8MTc3NzkwODg5MHww&ixlib=rb-4.1.0&q=85",
  skilledNursing: "https://customer-assets.emergentagent.com/job_homecare-nova-1/artifacts/njzr2er7_Screenshot%202026-06-04%20at%201.45.20%E2%80%AFPM.png",
  respiteCare: "https://images.unsplash.com/photo-1773227060422-ee506b865417?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxudXJzZSUyMGhlbHBpbmclMjBzZW5pb3IlMjBjaXRpemVufGVufDB8fHx8MTc3NzkwODg5MHww&ixlib=rb-4.1.0&q=85",
};
